import { Component, OnInit } from '@angular/core';
import { Select2Data } from 'ng-select2-component';
import Swal from 'sweetalert2';
import { LeadSubtypePermissionModel, RenaultLeadDashBoard, RenaultLeadDashBoardType, RenaultLeadFilter } from '../../../models/renault-lead-dto';
import { LeadService } from '../../../services/lead.service';
import * as Highcharts from 'highcharts';
import { LeadPermission, LeadType } from '../../../helpers/enum';
import { FormControl, FormGroup } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { DistributorParams } from 'src/app/models/shared-dto';
import { LeadPermissionModel } from 'src/app/models/lead-permission';
import { RenaultKpiGlobalFilter } from 'src/app/models/renault-kpi-filter-model';
import { combineLatestWith } from 'rxjs';
import { KpiService } from 'src/app/services/kpi.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'leads-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit {


  yearsData: Select2Data;
  monthsData: Select2Data;
  //typesData: Select2Data;
  //subtypesData: Select2Data;
  brandsData: Select2Data;

  yearsDefaultValue;
  monthsDefaultValue;
  //typesDefaultValue;
  //subtypesDefaultValue;
  brandsDefaultValue;
  filter: RenaultLeadFilter;
  tableFilter;
  permission: LeadPermissionModel;
  dataform: FormGroup;
  Dashboard: RenaultLeadDashBoard = new RenaultLeadDashBoard();
  DashboardR2: RenaultLeadDashBoardType = this.getEmptyDashboardType();
  DashboardR2Late: RenaultLeadDashBoardType = this.getEmptyDashboardType();
  distributorsR2Data: Select2Data;
  distributorR2DefaultValue: any = null;
  distributorR2LateDefaultValue: any = null;
  canViewTypePv = false;
  canViewTypeReclamacion = false;
  canViewTypeVn = false;
  canViewLead_24_7 = false;
  canSeeTopTable = false;
  permissionList: LeadSubtypePermissionModel[];
  distributorFilters: DistributorParams = new DistributorParams();
  loading = false;
  subtypesPvData: any;
  subtypesRecData: any;
  subtypesPvDefaultValue = null;
  subtypesRecDefaultValue = null;
  globalFilters: RenaultKpiGlobalFilter = new RenaultKpiGlobalFilter();
  userIsR2;
  showR2;

  chartTiempoRespuestaPv: any =
    {
      chart: {
        zoomType: 'xy',
        backgroundColor: 'transparent',
        style: {
          fontFamily: 'Read-Regular'
        }

      },
      title: {
        text: '',
        align: 'center',
        style: {
          color: '#000000',
          fontSize: '1rem',
          fontFamily: 'Renault-Bold, Arial, Helvetica, Liberation Sans, FreeSans, sans-serif'
        }
      },
      credits: {
        enabled: false
      },
      xAxis: {
        categories: [],
      },
      yAxis: [{
        min: 0,
        title: {
          text: ''
        }
      },
      { // Secondary yAxis
        title: {
          text: '',
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        },
        labels: {
          format: '{value:point.y:,.0f} H',
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        },
        opposite: true
      }],
      legend: {
        shadow: false
      },
      lang: {
        loading: 'Cargando...',
        printChart: 'Imprimir',
        downloadJPEG: 'Descargar JPEG',
        downloadPDF: 'Descargar PDF',
        downloadPNG: 'Descargar PNG',
        viewFullscreen: 'Pantalla completa',
        exitFullscreen: 'Exit from full screen',
        decimalPoint: ',',
        thousandsSep: '.'
      },
      tooltip: {
        shared: true
      },
      plotOptions: {
        column: {
          grouping: false,
          shadow: false,
          borderWidth: 0
        }
      },
      series: []

    };
  chartTiempoRespuestaReclamacion: any =
    {
      chart: {

        zoomType: 'xy',
        backgroundColor: 'transparent',

      },
      title: {
        text: '',
        align: 'center',
        style: {
          color: '#000000',
          fontSize: '1rem',
          fontFamily: 'Renault-Bold, Arial, Helvetica, Liberation Sans, FreeSans, sans-serif'
        }
      },
      credits: {
        enabled: false
      },
      xAxis: {
        categories: [],
      },
      yAxis: [{
        min: 0,
        title: {
          text: ''
        }
      },
      { // Secondary yAxis
        title: {
          text: '',
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        },
        labels: {
          format: '{value:point.y:,.0f} H',
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        },
        opposite: true
      }],
      legend: {
        shadow: false
      },
      lang: {
        loading: 'Cargando...',
        printChart: 'Imprimir',
        downloadJPEG: 'Descargar JPEG',
        downloadPDF: 'Descargar PDF',
        downloadPNG: 'Descargar PNG',
        viewFullscreen: 'Pantalla completa',
        exitFullscreen: 'Exit from full screen',
        decimalPoint: ',',
        thousandsSep: '.'
      },
      tooltip: {
        shared: true
      },
      plotOptions: {
        column: {
          grouping: false,
          shadow: false,
          borderWidth: 0
        }
      },
      series: []

    };
  chartTiempoRespuestaLead_24_7: any =
    {
      chart: {

        zoomType: 'xy',
        backgroundColor: 'transparent',

      },
      title: {
        text: '',
        align: 'center',
        style: {
          color: '#000000',
          fontSize: '1rem',
          fontFamily: 'Renault-Bold, Arial, Helvetica, Liberation Sans, FreeSans, sans-serif'
        }
      },
      credits: {
        enabled: false
      },
      xAxis: {
        categories: [],
      },
      yAxis: [{
        min: 0,
        title: {
          text: ''
        }
      },
      { // Secondary yAxis
        title: {
          text: '',
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        },
        labels: {
          format: '{value:point.y:,.0f} H',
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        },
        opposite: true
      }],
      legend: {
        shadow: false
      },
      lang: {
        loading: 'Cargando...',
        printChart: 'Imprimir',
        downloadJPEG: 'Descargar JPEG',
        downloadPDF: 'Descargar PDF',
        downloadPNG: 'Descargar PNG',
        viewFullscreen: 'Pantalla completa',
        exitFullscreen: 'Exit from full screen',
        decimalPoint: ',',
        thousandsSep: '.'
      },
      tooltip: {
        shared: true
      },
      plotOptions: {
        column: {
          grouping: false,
          shadow: false,
          borderWidth: 0
        }
      },
      series: []

    };

  private getEmptyDashboardType(): RenaultLeadDashBoardType {
    return {
      TotalClosedLeads: 0,
      TotalClosedLeadsPercent: '0',
      MediaInteractionLeads: '0',
      MediaResponseTime: { Hours: 0, Minutes: 0, Days: 0 },
      Agents: [],
      Distris: [],
      ChartResponseTime: { MonthList: [], Time: [] },
      InternetLeadsTotal: 0,
      InternetLeadsOnTime: 0,
      InternetLeadsOutTime: 0,
      InternetLeadsTreatedOnTime: 0,
      InternetLeadsTreatedOutTime: 0
    };
  }

  formatHM(time: any): string {
    if (!time) return '-';

    const h = time.Hours ?? 0;
    const m = time.Minutes ?? 0;

    return `${h} h ${m} min`;
  }

  constructor(private service: LeadService, private userService: UserService, private kpiService: KpiService, private sharedService: SharedService) { }

  ngOnInit() {

    this.getUserData();
    this.filter = new RenaultLeadFilter();
    this.filter.Year = new Date().getFullYear();
    this.tableFilter = JSON.stringify([this.filter]);
    this.getPermissionList();
    this.loadData();
    this.loadFilters();
    //this.getDashboard();
    //this.getDashboardResponseTimeLead();
    //this.getDashboardResponseTimeReclamacion();
    this.dataform = new FormGroup({
      Year: new FormControl(new Date().getFullYear().toString()),
      Month: new FormControl('0'),
      IdType: new FormControl(0),
      IdSubtype: new FormControl(0),
      IdBrand: new FormControl(0),
    });

  }

  getUserData() {

    this.userService.getUserData().subscribe(resp => {
      if (resp == null) return;
      this.userIsR2 = resp.IsR2;
      this.showR2 = (this.userIsR2 || resp.Admin)
      if (this.userIsR2 === false) {
        this.loadDistributorR2();
      }
      if (resp.Recsa || resp.RolesListString.some(x => x == "CallCenter")) {
        this.canSeeTopTable = true;
      }

    });
  }

  loadFilters() {
    const months$ = this.service.getMonths();
    const years$ = this.service.getYears();
    const globalFilters$ = this.kpiService.getGlobalFilters();

    months$.pipe(combineLatestWith(years$, globalFilters$))
      .subscribe(([months, years, globalFilters]) => {

        //MONTHS
        let result = [];
        result.push({ value: '0', label: '-Seleccionar-' });
        result.push.apply(result, months);
        this.monthsData = result;

        //YEARS
        this.yearsData = years;

        //GLOBAL FILTERS
        this.globalFilters = globalFilters;

        if (this.monthsData != null) {
          this.monthsDefaultValue = this.globalFilters.Month.toString();
        }

        if (this.yearsData != null) {
          this.yearsDefaultValue = this.globalFilters.Year.toString();
        }

        if (this.globalFilters.DistributorFilters != null && this.globalFilters.DistributorFilters.Distributor.length > 0) {

          this.userService.getUserDistributors().subscribe(distributors => {
            if (distributors != null && distributors.length > 0) {

              let pvGroup = distributors.find(x => x.IdDistributor == +this.globalFilters.DistributorFilters.Distributor[0]).IdPvGroup;

              if (this.distributorFilters.PvGroup.toString() != [pvGroup.toString()].toString()) {
                this.distributorFilters = {
                  ...this.distributorFilters,
                  PvGroup: [pvGroup.toString()]
                };
              }
              //this.filterBriefing();

            }
          });
        }

        this.search();
      });
  }

  loadData() {

    this.loadSubtypes(LeadType.Pv);
    this.loadSubtypes(LeadType.Reclamacion);

    // this.service.getLeadsTypes().subscribe(resp => {
    //   if (resp.length == 1) {
    //     this.typesData = resp;
    //     this.typesDefaultValue = resp[0].value;
    //     this.dataform.controls.IdType.setValue(this.typesDefaultValue)
    //     this.loadSubtypes({ option: { value: this.typesDefaultValue } });
    //   } else {
    //     let result = [];
    //     result.push({ value: 0, label: '-Seleccionar-' });
    //     result.push.apply(result, resp);
    //     this.typesData = result;
    //     this.typesDefaultValue = 0;
    //   }
    // }, (err) => {
    //   Swal.fire({
    //     icon: 'error',
    //     title: 'Error al recuperar los datos',
    //     text: 'Ocurrió un error',
    // buttonsStyling: false,
    // customClass: {
    //   confirmButton: 'btn btn-outline-secondary'
    // },
    // confirmButtonText: 'Cerrar'
    //   });
    // });

    // this.service.getLeadsSubtypes(false, LeadType.Pv).subscribe(resp => {
    //   if (resp.length == 1) {
    //     this.subtypesData = resp;
    //     this.subtypesDefaultValue = resp[0].value;
    //     this.dataform.controls.IdSubtype.setValue(this.subtypesDefaultValue)
    //   } else {
    //     let result = [];
    //     result.push({ value: 0, label: '-Seleccionar-' });
    //     result.push.apply(result, resp);
    //     this.subtypesData = result;
    //     this.subtypesDefaultValue = 0;
    //   }
    // }, (err) => {
    //   Swal.fire({
    //     icon: 'error',
    //     title: 'Error al recuperar los datos',
    //     text: 'Ocurrió un error',
    // buttonsStyling: false,
    // customClass: {
    //   confirmButton: 'btn btn-outline-secondary'
    // },
    // confirmButtonText: 'Cerrar'
    //   });
    // });

    this.service.getBrands().subscribe(resp => {
      if (resp.length == 1) {
        this.brandsData = resp;
        this.brandsDefaultValue = resp[0].value;
        this.dataform.controls.IdBrand.setValue(this.brandsDefaultValue)
      } else {
        let result = [];
        result.push({ value: 0, label: '-Seleccionar-' });
        result.push.apply(result, resp);
        this.brandsData = result;
        this.brandsDefaultValue = 0;
      }
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al recuperar los datos',
        text: 'Ocurrió un error',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-outline-secondary'
        },
        confirmButtonText: 'Cerrar'
      });
    });
  }

  loadDistributorR2() {
    this.sharedService.getDistributorR2().subscribe(resp => {
      let result = [];
      result.push({ value: null, label: 'Todos los distribuidores' });
      result.push.apply(result, resp);
      this.distributorsR2Data = result;
      this.distributorR2DefaultValue = null;
      this.distributorR2LateDefaultValue = null;
      this.getDashboardR2();
      this.getDashboardR2Late();
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al recuperar los datos',
        text: 'Ocurrió un error',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-outline-secondary'
        },
        confirmButtonText: 'Cerrar'
      });
    });
  }

  loadSubtypes(idType) {

    if (idType == LeadType.Pv) {

      this.subtypesPvData = [];

      this.service.getLeadsSubtypes(false, idType).subscribe(resp => {

        if (resp.length > 1 || resp.length == 0) {

          //sin el settimeout no coge el valor por defecto, es un misterio...
          setTimeout(() => {
            let result = [];
            result.push({ value: 0, label: '-Seleccionar-' });
            result.push.apply(result, resp);
            this.subtypesPvData = result;
            this.subtypesPvDefaultValue = 0;
          });

        } else {
          setTimeout(() => {
            this.subtypesPvData = resp;
            this.subtypesPvDefaultValue = resp[0].value;
          });
        }

      }, (err) => {
        Swal.fire({
          icon: 'error',
          title: 'Error al recuperar los datos',
          text: 'Ocurrió un error',
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-outline-secondary'
          },
          confirmButtonText: 'Cerrar'
        });
      });
    } else if (idType == LeadType.Reclamacion) {

      this.subtypesRecData = [];

      this.service.getLeadsSubtypes(false, idType).subscribe(resp => {

        if (resp.length > 1 || resp.length == 0) {
          let result = [];
          result.push({ value: 0, label: '-Seleccionar-' });
          result.push.apply(result, resp);
          this.subtypesRecData = result;
          //sin el settimeout no coge el valor por defecto, es un misterio...
          setTimeout(() => {
            this.subtypesRecDefaultValue = 0;
          });

        } else {
          setTimeout(() => {
            this.subtypesRecData = resp;
            this.subtypesRecDefaultValue = resp[0].value;
          });
        }

      }, (err) => {
        Swal.fire({
          icon: 'error',
          title: 'Error al recuperar los datos',
          text: 'Ocurrió un error',
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-outline-secondary'
          },
          confirmButtonText: 'Cerrar'
        });
      });
    }

  }

  search() {

    this.filter.Year = this.dataform.controls["Year"].value != 0 ? this.dataform.controls["Year"].value : null;
    this.filter.Month = this.dataform.controls["Month"].value != 0 ? this.dataform.controls["Month"].value : null;
    this.filter.IdDashboardSubtypePv = this.subtypesPvDefaultValue != 0 ? this.subtypesPvDefaultValue : null;
    this.filter.IdDashboardSubtypeRec = this.subtypesRecDefaultValue != 0 ? this.subtypesRecDefaultValue : null;
    this.tableFilter = JSON.stringify([this.filter]);
    this.getDashboard();
    //this.getDashboardResponseTimeLead();
    this.getDashboardResponseTimeReclamacion();
    if (this.userIsR2 === false) {
      this.getDashboardR2();
      this.getDashboardR2Late();
    }

  }

  resetFilters() {
    this.brandsDefaultValue = 0;

    if (this.subtypesPvData.length == 1)
      this.subtypesPvDefaultValue = this.subtypesPvData[0].value;
    else this.subtypesPvDefaultValue = 0

    if (this.subtypesRecData.length == 1)
      this.subtypesRecDefaultValue = this.subtypesRecData[0].value;
    else this.subtypesRecDefaultValue = 0

    this.yearsDefaultValue = new Date().getFullYear().toString();
    this.monthsDefaultValue = '0';
    this.distributorR2DefaultValue = null;
    this.distributorR2LateDefaultValue = null;

    this.filter = new RenaultLeadFilter();
    this.tableFilter = JSON.stringify([this.filter]);
    this.dataform.reset();

    this.dataform.controls["Year"].setValue(new Date().getFullYear().toString());
    this.dataform.controls["Month"].setValue('0');
    this.dataform.controls["IdType"].setValue(0);
    this.dataform.controls["IdSubtype"].setValue(0);
    this.dataform.controls["IdBrand"].setValue(0);

    this.loadData();
    this.filterData();
  }

  getDashboard() {

    this.loading = true;
    this.service.getDashboard(this.tableFilter).subscribe(resp => {

      this.Dashboard = resp;

      this.loading = false;
    });
  }

  onDistributorR2Change() {
    if (this.userIsR2 !== false) {
      return;
    }
    this.getDashboardR2();
  }

  onDistributorR2LateChange() {
    if (this.userIsR2 !== false) {
      return;
    }
    this.getDashboardR2Late();
  }

  getDashboardR2() {
    if (this.userIsR2 !== false) {
      return;
    }
    const idR2 = this.getSelectedDistributorR2();
    this.DashboardR2 = this.getEmptyDashboardType();
    this.service.getDashboardR2(this.tableFilter, idR2).subscribe(resp => {
      this.DashboardR2 = resp && resp.DashboardPV ? resp.DashboardPV : this.getEmptyDashboardType();
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al recuperar los datos',
        text: 'Ocurrió un error',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-outline-secondary'
        },
        confirmButtonText: 'Cerrar'
      });
    });
  }

  getDashboardR2Late() {
    if (this.userIsR2 !== false) {
      return;
    }
    const idR2 = this.getSelectedDistributorR2Late();
    this.DashboardR2Late = this.getEmptyDashboardType();
    this.service.getDashboardR2Late(this.tableFilter, idR2).subscribe(resp => {
      this.DashboardR2Late = resp && resp.DashboardPV ? resp.DashboardPV : this.getEmptyDashboardType();
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al recuperar los datos',
        text: 'Ocurrió un error',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-outline-secondary'
        },
        confirmButtonText: 'Cerrar'
      });
    });
  }

  private getSelectedDistributorR2(): number | null {
    if (this.distributorR2DefaultValue === null || this.distributorR2DefaultValue === undefined || this.distributorR2DefaultValue === 'null') {
      return null;
    }
    return +this.distributorR2DefaultValue;
  }

  private getSelectedDistributorR2Late(): number | null {
    if (this.distributorR2LateDefaultValue === null || this.distributorR2LateDefaultValue === undefined || this.distributorR2LateDefaultValue === 'null') {
      return null;
    }
    return +this.distributorR2LateDefaultValue;
  }

  /*getDashboardResponseTimeLead() {

    document.getElementById('chartTiempoRespuestaPv').innerHTML = ' <div class="loader position-relative">' +
      '<div class="lds-ellipsis">' +
      '<div></div>' +
      '<div></div>' +
      '<div></div>' +
      '<div></div>' +
      '</div>' +
      '</div>';

    this.service.GetDashboardChartResponseTimeLead(this.tableFilter).subscribe(resp => {


      this.chartTiempoRespuestaPv.series = [];
      this.chartTiempoRespuestaPv.xAxis.categories = resp.DashboardPV.ChartResponseTime.MonthList;
      this.chartTiempoRespuestaPv.title.text = "Tiempo medio de cierre " + this.filter.Year;
      this.chartTiempoRespuestaPv.series.push(
        {
          name: 'Tiempo Medio de cierre',
          color: '#4B9BF5',
          data: resp.DashboardPV.ChartResponseTime.Time,
          tooltip: {
            valueSuffix: 'H'
          }

        }
      )

      Highcharts.chart('chartTiempoRespuestaPv', this.chartTiempoRespuestaPv);


    });
  }*/

  getDashboardResponseTimeReclamacion() {


    document.getElementById('chartTiempoRespuestaReclamacion').innerHTML = ' <div class="loader position-relative">' +
      '<div class="lds-ellipsis">' +
      '<div></div>' +
      '<div></div>' +
      '<div></div>' +
      '<div></div>' +
      '</div>' +
      '</div>';

    this.service.GetDashboardChartResponseTimeReclamacion(this.tableFilter).subscribe(resp => {


      this.chartTiempoRespuestaReclamacion.series = [];
      this.chartTiempoRespuestaReclamacion.xAxis.categories = resp.DashboardReclamacion.ChartResponseTime.MonthList;
      this.chartTiempoRespuestaReclamacion.title.text = "Tiempo medio de cierre " + this.filter.Year;
      this.chartTiempoRespuestaReclamacion.series.push(
        {
          name: 'Tiempo Medio de cierre',
          color: '#D60000',
          data: resp.DashboardReclamacion.ChartResponseTime.Time,
          tooltip: {
            valueSuffix: 'H'
          }

        }
      )

      Highcharts.chart('chartTiempoRespuestaReclamacion', this.chartTiempoRespuestaReclamacion);

    });
  }

  getPermissionList() {

    this.service.GetPermissionList().subscribe(res => {

      this.permissionList = res;

      if (this.permissionList.some(o => o.IdType == LeadType.Pv && o.IdPermission == LeadPermission.View))
        this.canViewTypePv = true;

      if (this.permissionList.some(o => o.IdType == LeadType.Reclamacion && o.IdPermission == LeadPermission.View))
        this.canViewTypeReclamacion = true;

      if (this.permissionList.some(o => o.IdType == LeadType.Vn && o.IdPermission == LeadPermission.View))
        this.canViewTypeVn = true;

    });

  }

  filterData() {

    this.filter.DistributorFilters = this.distributorFilters;
    this.filter.Year = this.dataform.controls["Year"].value != 0 ? this.dataform.controls["Year"].value : null;
    this.filter.Month = this.dataform.controls["Month"].value != 0 ? this.dataform.controls["Month"].value : null;
    this.filter.IdBrand = this.dataform.controls["IdBrand"].value != 0 ? this.dataform.controls["IdBrand"].value : null;
    this.filter.IdDashboardSubtypePv = this.subtypesPvDefaultValue != 0 ? this.subtypesPvDefaultValue : null;
    this.filter.IdDashboardSubtypeRec = this.subtypesRecDefaultValue != 0 ? this.subtypesRecDefaultValue : null;
    this.tableFilter = JSON.stringify([this.filter]);
    this.getDashboard();
    //this.getDashboardResponseTimeLead();
    this.getDashboardResponseTimeReclamacion();
    if (this.userIsR2 === false) {
      this.getDashboardR2();
      this.getDashboardR2Late();
    }

  }

  getDistributorFilter(event: DistributorParams) {

    this.distributorFilters = event;
    this.filterData();
  }

  getReset(event: DistributorParams) {
    this.distributorFilters = event;
    this.resetFilters();
  }

  private get pv() {
    return this.Dashboard?.DashboardPV;
  }

  private sum(...values: Array<number | null | undefined>): number {
    return values.reduce((acc, v) => acc + (v || 0), 0);
  }

  private calcPercent(numerator: number, denominator: number | null | undefined): number {
    if (!denominator || denominator === 0) return 0;
    const raw = (numerator / denominator) * 100;
    return Math.max(0, Math.min(100, raw)); // clamp 0–100
  }

  private calcPercentFrom(
    src: any | null | undefined,
    numeratorKeys: string[],
    denominatorKeys: string[]
  ): number {
    if (!src) return 0;

    const numerator = this.sum(...numeratorKeys.map(k => src[k] as number));
    const denominator = this.sum(...denominatorKeys.map(k => src[k] as number));

    return this.calcPercent(numerator, denominator);
  }

  /* =======================
   *  LEADS INTERNET (PV)
   * ======================= */

  /** Total en tiempo (OnTime + TreatedOnTime) */
  get internetOnTimeTotal(): number {
    const pv = this.pv;
    if (!pv) return 0;

    return this.sum(
      pv.InternetLeadsOnTime,
      pv.InternetLeadsTreatedOnTime
    );
  }

  /** % en tiempo sobre el total */
  get internetOnTimePercent(): number {
    const pv = this.pv;
    if (!pv) return 0;

    return this.calcPercentFrom(
      pv,
      ['InternetLeadsOnTime', 'InternetLeadsTreatedOnTime'],
      ['InternetLeadsTotal']
    );
  }

  /** Total en retraso (OutTime + TreatedOutTime) */
  get internetLeadsOutTimeTotal(): number {
    const pv = this.pv;
    if (!pv) return 0;

    return this.sum(
      pv.InternetLeadsOutTime,
      pv.InternetLeadsTreatedOutTime
    );
  }

  /** % en retraso sobre el total */
  get internetLeadsOutTimePercent(): number {
    const pv = this.pv;
    if (!pv) return 0;

    return this.calcPercentFrom(
      pv,
      ['InternetLeadsOutTime', 'InternetLeadsTreatedOutTime'],
      ['InternetLeadsTotal']
    );
  }

  /** Pendientes: base = OnTime + OutTime */
  private get internetPendingBase(): number {
    const pv = this.pv;
    if (!pv) return 0;

    return this.sum(
      pv.InternetLeadsOnTime,
      pv.InternetLeadsOutTime
    );
  }

  /** % pendientes en tiempo (OnTime / (OnTime+OutTime)) */
  get internetPendingOnTimePercent(): number {
    const pv = this.pv;
    if (!pv) return 0;

    return this.calcPercent(
      pv.InternetLeadsOnTime || 0,
      this.internetPendingBase
    );
  }

  /** % pendientes en retraso (OutTime / (OnTime+OutTime)) */
  get internetPendingOutTimePercent(): number {
    const pv = this.pv;
    if (!pv) return 0;

    return this.calcPercent(
      pv.InternetLeadsOutTime || 0,
      this.internetPendingBase
    );
  }

  /** Tratados: base = TreatedOnTime + TreatedOutTime */
  private get internetTreatedBase(): number {
    const pv = this.pv;
    if (!pv) return 0;

    return this.sum(
      pv.InternetLeadsTreatedOnTime,
      pv.InternetLeadsTreatedOutTime
    );
  }

  /** % tratados en tiempo */
  get internetTreatedOnTimePercent(): number {
    const pv = this.pv;
    if (!pv) return 0;

    return this.calcPercent(
      pv.InternetLeadsTreatedOnTime || 0,
      this.internetTreatedBase
    );
  }

  /** % tratados en retraso */
  get internetTreatedOutTimePercent(): number {
    const pv = this.pv;
    if (!pv) return 0;

    return this.calcPercent(
      pv.InternetLeadsTreatedOutTime || 0,
      this.internetTreatedBase
    );
  }

  /* =======================
   *  LEADS R2 LATE
   * ======================= */

  private get r2Late() {
    return this.DashboardR2Late;
  }

  /** % en tiempo (OnTime + TreatedOnTime) / Total */
  get r2LateOnTimePercent(): number {
    return this.calcPercentFrom(
      this.r2Late,
      ['InternetLeadsOnTime', 'InternetLeadsTreatedOnTime'],
      ['InternetLeadsTotal']
    );
  }

  /** % en retraso (OutTime + TreatedOutTime) / Total */
  get r2LateOutTimePercent(): number {
    return this.calcPercentFrom(
      this.r2Late,
      ['InternetLeadsOutTime', 'InternetLeadsTreatedOutTime'],
      ['InternetLeadsTotal']
    );
  }

  /** Pendientes R2Late: base = OnTime + OutTime */
  private get r2LatePendingBase(): number {
    const src = this.r2Late;
    if (!src) return 0;

    return this.sum(
      src.InternetLeadsOnTime,
      src.InternetLeadsOutTime
    );
  }

  get r2LatePendingOnTimePercent(): number {
    const src = this.r2Late;
    if (!src) return 0;

    return this.calcPercent(
      src.InternetLeadsOnTime || 0,
      this.r2LatePendingBase
    );
  }

  get r2LatePendingOutTimePercent(): number {
    const src = this.r2Late;
    if (!src) return 0;

    return this.calcPercent(
      src.InternetLeadsOutTime || 0,
      this.r2LatePendingBase
    );
  }

  /** Tratados R2Late: base = TreatedOnTime + TreatedOutTime */
  private get r2LateTreatedBase(): number {
    const src = this.r2Late;
    if (!src) return 0;

    return this.sum(
      src.InternetLeadsTreatedOnTime,
      src.InternetLeadsTreatedOutTime
    );
  }

  get r2LateTreatedOnTimePercent(): number {
    const src = this.r2Late;
    if (!src) return 0;

    return this.calcPercent(
      src.InternetLeadsTreatedOnTime || 0,
      this.r2LateTreatedBase
    );
  }

  get r2LateTreatedOutTimePercent(): number {
    const src = this.r2Late;
    if (!src) return 0;

    return this.calcPercent(
      src.InternetLeadsTreatedOutTime || 0,
      this.r2LateTreatedBase
    );
  }

  /* =======================
   *  LEADS R2
   * ======================= */

  private get r2() {
    return this.DashboardR2;
  }

  /** % en tiempo (OnTime + TreatedOnTime) / Total */
  get r2OnTimePercent(): number {
    return this.calcPercentFrom(
      this.r2,
      ['InternetLeadsOnTime', 'InternetLeadsTreatedOnTime'],
      ['InternetLeadsTotal']
    );
  }

  /** % en retraso (OutTime + TreatedOutTime) / Total */
  get r2OutTimePercent(): number {
    return this.calcPercentFrom(
      this.r2,
      ['InternetLeadsOutTime', 'InternetLeadsTreatedOutTime'],
      ['InternetLeadsTotal']
    );
  }

  /** Pendientes R2: base = OnTime + OutTime */
  private get r2PendingBase(): number {
    const src = this.r2;
    if (!src) return 0;

    return this.sum(
      src.InternetLeadsOnTime,
      src.InternetLeadsOutTime
    );
  }

  get r2PendingOnTimePercent(): number {
    const src = this.r2;
    if (!src) return 0;

    return this.calcPercent(
      src.InternetLeadsOnTime || 0,
      this.r2PendingBase
    );
  }

  get r2PendingOutTimePercent(): number {
    const src = this.r2;
    if (!src) return 0;

    return this.calcPercent(
      src.InternetLeadsOutTime || 0,
      this.r2PendingBase
    );
  }

  /** Tratados R2: base = TreatedOnTime + TreatedOutTime */
  private get r2TreatedBase(): number {
    const src = this.r2;
    if (!src) return 0;

    return this.sum(
      src.InternetLeadsTreatedOnTime,
      src.InternetLeadsTreatedOutTime
    );
  }

  get r2TreatedOnTimePercent(): number {
    const src = this.r2;
    if (!src) return 0;

    return this.calcPercent(
      src.InternetLeadsTreatedOnTime || 0,
      this.r2TreatedBase
    );
  }

  get r2TreatedOutTimePercent(): number {
    const src = this.r2;
    if (!src) return 0;

    return this.calcPercent(
      src.InternetLeadsTreatedOutTime || 0,
      this.r2TreatedBase
    );
  }
}
